import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class SeedService {
    private baseUrl: string = environment.BASE_URL;

    constructor(private http: HttpClient) { }

    loginAsAdmin(email: string, password: string): Observable<any> {
        return this.http.post(`${this.baseUrl}/api/admin/login`, { emailAddress: email, password });
    }

    seedUsers(count: number, authToken: string): Observable<any> {
        return this.http.post(`${this.baseUrl}/api/utils/users?numberOfUsersToCreate=${count}`, null, {
            headers: new HttpHeaders({
                Authorization: `Bearer ${authToken}`
            }),
        });
    }

    seedTickets(count: number, authToken: string): Observable<any> {
        return this.http.post(`${this.baseUrl}/api/utils/tickets?maximumNumberOfTickets=${count}`, null, {
            headers: new HttpHeaders({
                Authorization: `Bearer ${authToken}`
            }),
        });
    }
}
